import { useRecoilState } from 'recoil'
import { chataiDrawerOpenState } from '~/states/atoms/ChatAI'

import CallToActionOutlinedIcon from '@mui/icons-material/CallToActionOutlined'
import Button from '@mui/material/Button'
import { useTheme } from '@mui/material/styles'

export type ChataiConversationDrawerOpenButtonProps = {
  anchor?: 'lefttop' | 'none'
}

export function ChataiConversationDrawerOpenButton({ anchor = 'none' }: ChataiConversationDrawerOpenButtonProps) {
  const theme = useTheme()
  const [open, setOpen] = useRecoilState(chataiDrawerOpenState)

  return (
    <Button
      size="small"
      variant="outlined"
      color="standard"
      sx={{
        p: 0.7,

        minWidth: 'auto',
        backgroundColor: theme.palette.standard.light,
        ...(anchor === 'lefttop'
          ? {
              // position: 'sticky',
              position: 'absolute',
              top: 8,
              left: 8,
              zIndex: theme.zIndex.drawer + 1,
              mt: 6,
            }
          : {}),
      }}
      onClick={() => setOpen(!open)}>
      <CallToActionOutlinedIcon
        fontSize="small"
        sx={{
          transform: 'rotate(90deg) scale(0.9)',
        }}
      />
    </Button>
  )
}
